import React, { createContext, useContext, useState, useEffect } from 'react';

const Ctx = createContext();

export const Router = ({ children }) => {
  const [path, setPath] = useState(window.location.hash.slice(1) || '/');

  useEffect(() => {
    const onHashChange = () => setPath(window.location.hash.slice(1) || '/');
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const go = (to) => {
    window.location.hash = to;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return <Ctx.Provider value={{ path, go }}>{children}</Ctx.Provider>;
};

export const useR = () => useContext(Ctx);

export const L = ({ to, children, className = '', ...props }) => {
  const { go } = useR();
  return (
    <a
      href={`#${to}`}
      onClick={(e) => {
        e.preventDefault();
        go(to);
      }}
      className={className}
      style={{ textDecoration: 'none', ...props.style }}
      {...props}
    >
      {children}
    </a>
  );
};